import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from "react-router";
import {useAuth} from "../context/authContext";
import {Employee, loginService} from "../services/employee";
import {LuEye} from "react-icons/lu";
import { TbEyeClosed } from 'react-icons/tb';
import Label from "../components/Label";
import Input from "../components/input/InputField";
import Button from "../components/button/Button";
import AuthLayout from "../components/AuthPageLayout";
import {AxiosError} from "axios";

const Login = () => {
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [errors, setErrors] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState(false);


    const {setEmp, employeeI} = useAuth()
    const navigate = useNavigate();

    useEffect(() => {
        if (employeeI) navigate("/dashboard", { replace: true });
    }, []);

    const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        try {
            const result = await loginService({
                email: email,
                password: password,
            })
            // console.log(result.headers)
            const data: Employee = result.data;
            setEmp(data);
            // console.log(result)
            navigate("/dashboard", { replace: true });

            // console.log(result.data)
        } catch (error) {
            // if (error) {
            //     // @ts-ignore
            //     setError(error.response.data.error);
            //     return;
            // }
            if (error instanceof AxiosError) {
                if (error.response) {
                    if (error.response.status === 500) {
                        setErrors("Something on our end went wrong");
                        setLoading(false);
                        return;
                    }
                    if (error.response.data) {
                        setErrors(error.response.data.error);
                        setLoading(false);
                        return;
                    }
                    setErrors("Something went wrong!");
                    setLoading(false);
                    return;
                }
                setErrors("Something went wrong!");
                setLoading(false);
                return;
            }
            setErrors("Something went wrong!");

        }

        setLoading(false);

    }


    return (
        <AuthLayout>
            <div className="flex flex-col flex-1">

                <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
                    <div>
                        <div className="mb-5 sm:mb-8">
                            {
                                errors.length > 0 && (
                                    <div className={`w-full h-fit flex flex-row lg:justify-start justify-center`}>
                                        <small className={`px-2 py-1.5 ring-1 ring-red-500 bg-red-300/70 rounded-md text-red-500`}>{errors}</small>

                                    </div>
                                )
                            }
                            <h1 className="mb-2 text-4xl max-lg:text-center max-lg:text-2xl font-semibold text-gray-800 text-title-smcsm:text-title-md">
                                Sign In
                            </h1>
                            <div className="lg:hidden flex flex-col items-center justify-center w-full mb-2">
                                <Link to="/" className="block">
                                    <img
                                        width={231}
                                        height={48}
                                        src="https://kmcwebsite.nyc3.cdn.digitaloceanspaces.com/assets/images/logo.png"
                                        alt="Logo"
                                    />
                                </Link>
                                <p className="text-center text-gray-900">
                                    Kiira Integrated Information Systems
                                </p>
                            </div>
                            <p className="text-sm max-lg:text-center  text-gray-500">
                                Enter your company email and password to sign in!
                            </p>
                        </div>
                        <div>
                            <form onSubmit={submitHandler}>
                                <div className="space-y-6">
                                    <div>
                                        <Label>
                                            Email <span className="text-red-500">*</span>{" "}
                                        </Label>
                                        <Input
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            type={"email"} placeholder="jon@kiiramotors.com" />
                                    </div>
                                    <div>
                                        <Label>
                                            Password <span className="text-red-500">*</span>{" "}
                                        </Label>
                                        <div className="relative">
                                            <Input
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Enter your password"
                                            />
                                            <span
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                                            >
                                              {showPassword ? (
                                                  <LuEye  className="text-gray-500  size-5" />
                                              ) : (
                                                  <TbEyeClosed className="text-gray-500 size-5" />
                                              )}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end">
                                        <Link
                                            to="/reset-password"
                                            className="text-sm text-orange-500 hover:text-orange-600"
                                        >
                                            Forgot password?
                                        </Link>
                                    </div>
                                    <div>
                                        <Button disabled={loading} className="w-full" size="sm">
                                            {loading? "Signing in..." : "Sign In"}
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </AuthLayout>
    );
};


export default Login;